import { render, staticRenderFns } from "./StrapiCategorieLettreTechniqueComponent.vue?vue&type=template&id=639d1942"
import script from "./StrapiCategorieLettreTechniqueComponent.vue?vue&type=script&lang=js"
export * from "./StrapiCategorieLettreTechniqueComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports